import { Currency } from '@/api/apis/quote';

export const getCurrencyFormatter = (currency = Currency.USD, options?: Intl.NumberFormatOptions) => {
  // TODO: Add locales integration
  return new Intl.NumberFormat('en-US', {
    ...options,
    style: 'currency',
    currency,
  });
};

export const formatCurrency = (value: number, currencyCode = Currency.USD, options?: Intl.NumberFormatOptions) => {
  return getCurrencyFormatter(currencyCode, options).format(value);
};

export const getCurrencySymbol = (currencyCode = Currency.USD) => {
  const formattedString = formatCurrency(0, currencyCode, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formattedString.replace(/\d/g, '').trim();
};
